export default __webpack_public_path__ + "static/slide-04-cc61e90c793657205bbfd46ea63d77d1.png";